import { Bot } from "./bot";

export class ActionRow {
  public id: string;
  public jsonDeterminants: string = "";
  public bots: Bot[] = [];
  public sortOrderNumber: number;
  public parallel: boolean = false;
  public mandatory: boolean = false;
  public multipleBot: boolean = false;
  public multipleFieldKey: string;
  public targetTabComponentKey: string = null;
  public targetElementKey: string = null;
}
